// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible'

import CryptoJs from '@/assets/aes.min'

Vue.prototype.$CryptoJs = CryptoJs;



Vue.use(Vant);
import store from './store'
//import '@/mock' //Mock 数据

Vue.use(ElementUI)
Vue.config.productionTip = false


import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

export default vue;



// WEBPACK FOOTER //
// ./src/main.js